import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { depositShape, historyShape } from '../../../utils/propTypes';
import ColorDollarAmountCell from '../../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import { forEach } from 'lodash';
import { getChargebackTableLink } from '../../Chargebacks/chargebacksActions';
import { Link, withRouter } from 'react-router-dom';
import { get, isEmpty } from 'lodash';
import classnames from 'classnames';
import { getBatchOfTransactionsLink } from '../../Transactions/transactionsActions';
import { currencyMapper, achDetailType } from '@nexio/emvio-util-app';
import './DepositBatchSummary.scss';
import { getCustomAccess } from '../../Self/selfEntity';
import { doesRoleHaveAccessToFeature } from '../../../utils/customRole';
import config from '../../../config/config';

export class DepositBatchSummary extends Component {
    static propTypes = {
        data: depositShape,
        history: historyShape,
        customAccess: PropTypes.any
    };

    renderRows(depositBatchSummary, date) {
        const feeRows = [];
        const batchRows = [];
        const chargebackRows = [];
        const adjustmentRows = [];
        const reserveRows = [];
        const splitRows = [];

        forEach(depositBatchSummary, (row, index) => {
            switch (row.type) {
                case achDetailType.batch:
                    batchRows.push(this.renderBatchRow(row, date));
                    break;
                case achDetailType.chargeback:
                    if (doesRoleHaveAccessToFeature(this.props.customAccess, { [config.serviceArns.chargeback]: ['GET/v3'] })) {
                        chargebackRows.push(this.renderRow(row, index, 'Chargebacks', getChargebackTableLink(row.achDetailId, date)));
                    } else {
                        chargebackRows.push(this.renderRow(row, index, 'Chargebacks'));
                    }

                    break;
                case achDetailType.fees:
                    feeRows.push(this.renderRow(row, index, 'Fees'));
                    break;
                case achDetailType.adjustment:
                    adjustmentRows.push(this.renderRow(row, index, 'Adjustments'));
                    break;
                case achDetailType.split:
                    splitRows.push(this.renderRow(row, index, 'Split Funding'));
                    break;
                case achDetailType.reserve:
                case achDetailType.reserveRelease:
                case achDetailType.reserveHeld:
                    reserveRows.push(this.renderRow(row, index, 'Reserve'));
                    break;
                default:
                    console.error('Unknown batch type: ', row.type);
                    break;
            }
        });

        return [...batchRows, ...adjustmentRows, ...chargebackRows, ...feeRows, ...reserveRows, ...splitRows];
    }

    renderBatchRow(batchRow, date) {
        //Tsys thirdPartyFundedAmount will include BOTH third party funded and rejected amounts
        const closedBatchAmount = batchRow.amount + batchRow.thirdPartyFundedAmount;
        const batchRef = get(batchRow, 'processor.batchRef');

        const doesHaveAccessToTransactionData = doesRoleHaveAccessToFeature(this.props.customAccess, { [config.serviceArns.transaction]: ['GET/v3'] });

        return (
            <tr key={batchRow.achDetailId}>
                {doesHaveAccessToTransactionData ?
                    <td className="link">
                        <Link className="emvio-batch-id" to={getBatchOfTransactionsLink(batchRow.achDetailId, date)}>
                            {batchRef}
                        </Link>
                    </td>
                    :
                    <td>{ batchRef }</td>
                }
                <td><ColorDollarAmountCell amount={closedBatchAmount} currencyCode={currencyMapper[this.props.data.currencyId].code} /></td>
                <td><ColorDollarAmountCell amount={batchRow.thirdPartyFundedAmount} currencyCode={currencyMapper[this.props.data.currencyId].code} /></td>
                <td><ColorDollarAmountCell amount={batchRow.amount} currencyCode={currencyMapper[this.props.data.currencyId].code} /></td>
            </tr>
        );
    }

    renderRow(row, index, label, clickthroughFunction) {
        if (row) {
            const rowLabel = clickthroughFunction ? <Link to={clickthroughFunction}>{label}</Link> : label;

            return (
                <tr key={`row${index}`}>
                    <td className={classnames('bolden', { 'link': clickthroughFunction })}>{rowLabel}</td>
                    <td></td>
                    <td></td>
                    <td><ColorDollarAmountCell amount={row.amount} currencyCode={currencyMapper[this.props.data.currencyId].code} /></td>
                </tr>
            );
        }
    }

    renderTotalRow(depositBatchSummary) {
        if (depositBatchSummary.length > 0) {
            let closedBatchTotal = 0;
            let thirdPartyTotal = 0;
            let depositTotal = 0;

            depositBatchSummary.forEach((row) => {
                if (row.type === achDetailType.batch) {
                    closedBatchTotal += (row.amount + row.thirdPartyFundedAmount);
                    thirdPartyTotal += row.thirdPartyFundedAmount;
                }

                depositTotal += row.amount;
            });

            return (
                <tr className="total-row">
                    <td>Total</td>
                    <td><ColorDollarAmountCell amount={closedBatchTotal} currencyCode={currencyMapper[this.props.data.currencyId].code} /></td>
                    <td><ColorDollarAmountCell amount={thirdPartyTotal} currencyCode={currencyMapper[this.props.data.currencyId].code} /></td>
                    <td><ColorDollarAmountCell amount={depositTotal} currencyCode={currencyMapper[this.props.data.currencyId].code} /></td>
                </tr>
            );
        }
    }

    render() {
        const detailsMessage = 'Details were not provided by Gateway.';

        return (
            <div className="emvio-deposit-batch-summary">
                {!isEmpty(this.props.data.details)
                    ? <table className="batch-table" cellSpacing="0">
                        <tbody>
                            <tr className="header-row">
                                <th>Processor Batch ID</th>
                                <th>Closed Batch</th>
                                <th className="hover-header">
                                    Non-Funded*
                                    <span className="hover-text">* Includes third-party funded (Wright Express and non-OptBlue American Express) and rejects.</span>
                                </th>
                                <th>Deposit</th>
                            </tr>
                            {this.renderRows(this.props.data.details, this.props.data.date)}
                            {this.renderTotalRow(this.props.data.details)}
                        </tbody>
                    </table>
                    : <div className="no-details">{detailsMessage}</div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        customAccess: getCustomAccess(state)
    };
}

export default withRouter(connect(mapStateToProps)(DepositBatchSummary));
